export default "__VITE_ASSET__BaPDt83O__"